import React from "react"
import ico_wa from "assets/img/icon/ico_whatsapp.svg"

//Components
import { Button } from "components/anti"
import { useRouter } from "next/router"

const OurStoreComp = ({ data, locale }) => {
  const router = useRouter()
  return (
    <section className="sc-our-store">
      <div className="container">
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => router.back()}
          />
        </div>
        <h3 className="title-page">
          {locale === "id" ? "Toko Kami" : "Our Store"}
        </h3>
        <h6 className="subtitle-page">
          {locale === "id"
            ? "Temukan kami di toko offline kami"
            : "Find us in our offline store"}
        </h6>
        <div className="row">
          <div className="col-md-7 offset-md-1 order-md-2 mb-5 mb-md-0">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.500172886536!2d106.72657771476901!3d-6.197547095513406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f741e75532df%3A0xaa5d142562d4c6a0!2sNAGAREY%20Furniture%20%26%20Home%20Accesories!5e0!3m2!1sen!2sid!4v1649143862140!5m2!1sen!2sid"
              width="600"
              height="450"
              style={{
                border: "0",
                width: "100%",
                height: "auto",
                aspectRatio: "4 / 3",
              }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="col-md-3 order-md-1 order-md-1">
            <h6 className="title-content">
              {locale === "id"
                ? "NAGAREY Furniture & Aksesoris Rumah"
                : "NAGAREY Furniture & Home Accesories"}
            </h6>
            <h6 className="text-label">
              {locale === "id" ? "Direktori" : "Directory"}
            </h6>
            <div
              className="text-value h6"
              dangerouslySetInnerHTML={{ __html: data?.directory }}
            />
            <h6 className="text-label">
              {locale === "id" ? "Informasi tambahan" : "Additional Info"}
            </h6>
            <div
              className="text-value h6 grid"
              dangerouslySetInnerHTML={{ __html: data?.additionalInfo }}
            />
            <h6 className="text-label">
              {locale === "id" ? "Lokasi" : "Location"}
            </h6>
            <h6 className="text-value">
              Jl. Jalur 20 No.9, RW.10, Meruya Utara, Kec. Kembangan, Kota
              Jakarta Barat, Daerah Khusus Ibukota Jakarta 11650
            </h6>
            <div className="mb-4">
              <Button
                className="w-100"
                variant="primary"
                link="https://goo.gl/maps/nbNM7VXgHUiNFS9S6"
                target="_blank"
              >
                {locale === "id" ? "Dapatkan Arah" : "Get Direction"}
              </Button>
            </div>
            <h6 className="text-label">
              {locale === "id" ? "Jam buka" : "Opening Hours"}
            </h6>
            <div
              className="text-value h6 grid"
              dangerouslySetInnerHTML={{ __html: data?.openingHours }}
            />
            <h6 className="text-label">
              {locale === "id" ? "Nomor telepon" : "Phone Number"}
            </h6>
            <Button
              variant="white"
              // link="/wishlist"
              link="https://api.whatsapp.com/send?phone=6282210769566"
              target="__blank"
              className="w-100"
            >
              <img src={ico_wa?.src} alt={"ico_wa"} className={"mr-2"} />{" "}
              082210769566
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default OurStoreComp
